export const IngredientsList = {
  bindings: {
    ingredients: '<',
  },

  transclude: true,

  template: `
    <div class="ingredients-list text-left">
      <div class="row">
        <div class="col-md-6">
          <ul class="fa-ul">
            <li
              ng-repeat="ingredient in $ctrl.ingredients track by $index"
              ng-if="$index < ($ctrl.ingredients.length / 2)">
                <i class="fa fa-li fa-square-o"></i>
                {{ ingredient }}
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <ul class="fa-ul">
            <li
              ng-repeat="ingredient in $ctrl.ingredients track by $index"
              ng-if="$index >= ($ctrl.ingredients.length / 2)">
                <i class="fa fa-li fa-square-o"></i>
                {{ ingredient }}
            </li>
          </ul>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Ingredients/IngredientsList.js